import VehicleBlockComponentsShell from "./VehicleBlockComponentsShell";

export default VehicleBlockComponentsShell;
export { VehicleBlockComponentsShell };
